import { useEffect, useState } from "react";

const CountryPaymentGatewaySearch = ({ search = "", onSearch, }) => {

    const [value, setValue] = useState(search);

    useEffect(() => {
        setValue(search);
    }, [search]);

    const handleSearch = () => { onSearch(value); };
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    };

    return (
        <div className="relative w-full max-w-md">
            <svg
                viewBox="0 0 24 24"
                className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <circle cx="11" cy="11" r="7" />
                <path strokeLinecap="round" d="m21 21-4.3-4.3" />
            </svg>

            <input
                type="text"
                placeholder="Search by country..."
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={handleKeyDown}
                className="w-full rounded-full border border-slate-200 bg-white py-2.5 pl-11 pr-24 text-sm text-slate-800 placeholder:text-slate-400 shadow-sm outline-none transition focus:border-emerald-500 focus:ring-2 focus:ring-emerald-500/20"
            />

            <button
                onClick={handleSearch}
                className="absolute right-1.5 top-1/2 -translate-y-1/2 rounded-full bg-emerald-600 px-4 py-1.5 text-sm font-medium text-white transition hover:bg-emerald-700"
            >
                Search
            </button>
        </div>
    );
};

export default CountryPaymentGatewaySearch;